export default __webpack_public_path__ + "static/media/search-no-results-2x.eccfde3f.png";